import React from "react";
import { Box, FormHelperText, Grid, Paper, Stack, TextField } from "@mui/material";
import styled from "styled-components";
import { LoadingButton } from "@mui/lab";
import Terms from "../../components/terms";
import Div from "../../components/div";
import request from "../../utils/request";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const ResponseText = styled(FormHelperText)`
    color: ${({ theme, error }) => (error ? theme.palette.error.main : theme.palette.primary.main)};
`;

const UpgradeInquiry = () => {
    const [termsError, setTermsError] = React.useState(false);
    const [checkedTerms, setCheckedTerms] = React.useState(false);
    const [inquiry, setInquiry] = React.useState({ value: "", minLength: 20 });
    const [role, setRole] = React.useState({ value: "", minLength: 3 });
    const [size, setSize] = React.useState({ value: "", minLength: 1 });
    const [loading, setLoading] = React.useState(false);
    const [response, setResponse] = React.useState();

    const handleTermsChange = (event) => {
        setCheckedTerms(event.target.checked);
        setTermsError(false);
    };

    const changeInquiryValue = (event) => {
        setInquiry({ ...inquiry, value: event.target.value, error: undefined });
    };

    const changeRoleValue = (event) => {
        setRole({ ...role, value: event.target.value, error: undefined });
    };

    const changeSizeValue = (event) => {
        setSize({ ...size, value: event.target.value, error: undefined });
    };

    const checkInquiryValue = () => {
        if (inquiry.value.length < inquiry.minLength)
            setInquiry({
                ...inquiry,
                error: `Must be at least ${inquiry.minLength} characters`,
            });
    };

    const checkRoleValue = () => {
        if (role.value.length < role.minLength)
            setRole({
                ...role,
                error: `Must be at least ${role.minLength} characters`,
            });
    };

    const checkSizeValue = () => {
        if (size.value.length < size.minLength)
            setSize({
                ...size,
                error: `Must be at least ${size.minLength} characters`,
            });
    };

    const clearInquiryError = () => {
        setInquiry({ ...inquiry, error: undefined });
        setTermsError(false);
    };
    const clearRoleError = () => {
        setRole({ ...role, error: undefined });
        setTermsError(false);
    };
    const clearSizeError = () => {
        setSize({ ...size, error: undefined });
        setTermsError(false);
    };

    const onFormSubmit = async (e) => {
        e.preventDefault();
        checkInquiryValue();
        checkRoleValue();
        checkSizeValue();
        if (!checkedTerms) return setTermsError(true);
        if (!!inquiry.error || !!role.error || !!size.error) return undefined;
        try {
            setLoading(true);
            await request("/api/users/inquiry", {
                method: "POST",
                body: JSON.stringify({
                    role: role.value,
                    companySize: size.value,
                    text: inquiry.value,
                }),
            });
            setResponse({ message: `Inquiry was sent. We'll respond in 24h` });
        } catch (error) {
            setResponse({ message: `Error sending inquiry`, error: true });
        }
        return setLoading(false);
    };

    return (
        <Paper
            style={{
                width: "100%",
                maxWidth: "666px",
                marginTop: "9vh",
            }}
        >
            <Box p={4}>
                <form onSubmit={onFormSubmit}>
                    <Grid container spacing={3} direction="column">
                        <Grid item>
                            <Div style={{ maxWidth: "450px" }}>
                                <H1>Contact Adadot</H1>
                                <H2>
                                    Please state the status of your business and we will get back to
                                    you with a plan that meets your needs
                                </H2>
                            </Div>
                        </Grid>
                        <Grid item>
                            <Stack spacing={2} direction="row">
                                <TextField
                                    fullWidth
                                    label="Your Role"
                                    error={!!role.error}
                                    id="role"
                                    value={role.value}
                                    helperText={role.error}
                                    variant="outlined"
                                    onChange={changeRoleValue}
                                    onBlur={checkRoleValue}
                                    onFocus={clearRoleError}
                                />
                                <TextField
                                    fullWidth
                                    label="Company Size"
                                    error={!!size.error}
                                    id="size"
                                    value={size.value}
                                    helperText={size.error}
                                    variant="outlined"
                                    onChange={changeSizeValue}
                                    onBlur={checkSizeValue}
                                    onFocus={clearSizeError}
                                />
                            </Stack>
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Your Inquiry"
                                multiline
                                rows={4}
                                fullWidth
                                error={!!inquiry.error}
                                id="inquiry"
                                value={inquiry.value}
                                helperText={inquiry.error}
                                variant="outlined"
                                onChange={changeInquiryValue}
                                onBlur={checkInquiryValue}
                                onFocus={clearInquiryError}
                            />
                        </Grid>
                        <Grid item>
                            <Terms
                                checkedTerms={checkedTerms}
                                handleTermsChange={handleTermsChange}
                                termsError={termsError}
                            />
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                type="submit"
                                loading={loading}
                            >
                                Submit Inquiry
                            </LoadingButton>
                            {response && (
                                <ResponseText error={response.error}>
                                    {response.message}
                                </ResponseText>
                            )}
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Paper>
    );
};

export default UpgradeInquiry;
